import React, { useEffect, useState } from "react";
import { adminApi } from "@/lib/adminApi";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { UserCheck, Clock } from "lucide-react";
import { formatDateTime } from "@/lib/dateFormat";

export const AccessRequestsSection = () => {
  const [rows, setRows] = useState([]);
  const load = () => adminApi.accessRequests().then(setRows);
  useEffect(() => { load(); }, []);

  const approve = async (id) => {
    try { await adminApi.approveAccess(id); toast.success("Approved & added to roster (red status)"); load(); }
    catch { toast.error("Approve failed"); }
  };

  return (
    <div>
      <h2 className="mb-5 font-serif text-2xl font-semibold text-gmoaa-green">Access Requests ({rows.length})</h2>
      {rows.length === 0 && <p className="text-gmoaa-text-muted">No access requests yet.</p>}
      <div className="space-y-2">
        {rows.map((r) => (
          <div key={r.id} className="flex items-center justify-between rounded-xl border border-gmoaa-border-subtle bg-white p-4">
            <div>
              <p className="flex items-center gap-2 font-medium text-gmoaa-text-dark">{r.name}
                <span className={`rounded-full px-2 py-0.5 text-[10px] font-semibold ${r.status === "approved" ? "bg-gmoaa-green-light text-gmoaa-green" : "bg-gmoaa-saffron-light text-gmoaa-saffron-hover"}`}>{r.status}</span>
              </p>
              <p className="text-xs text-gmoaa-text-muted">{r.mobile} · {r.email || "no email"} · {r.district}{r.registration_no ? ` · Reg: ${r.registration_no}` : ""}</p>
              {r.message && <p className="mt-1 text-sm text-gmoaa-text-muted">{r.message}</p>}
            </div>
            {r.status !== "approved" && <Button size="sm" onClick={() => approve(r.id)} className="bg-gmoaa-green text-white hover:bg-gmoaa-green-hover"><UserCheck size={15} className="mr-1" /> Approve</Button>}
          </div>
        ))}
      </div>
    </div>
  );
};

export const AuditSection = () => {
  const [rows, setRows] = useState([]);
  useEffect(() => { adminApi.audit().then(setRows); }, []);
  return (
    <div>
      <h2 className="mb-5 font-serif text-2xl font-semibold text-gmoaa-green">Audit Log</h2>
      {rows.length === 0 && <p className="text-gmoaa-text-muted">No actions logged yet.</p>}
      <div className="space-y-1.5">
        {rows.map((r) => (
          <div key={r.id} className="flex items-center gap-3 rounded-lg border border-gmoaa-border-subtle bg-white px-3 py-2 text-sm">
            <Clock size={14} className="shrink-0 text-gmoaa-text-muted" />
            <span className="font-medium text-gmoaa-green">{r.action}</span>
            <span className="text-gmoaa-text-muted">{r.entity}/{r.entity_id?.slice(0, 8)}</span>
            <span className="ml-auto text-xs text-gmoaa-text-muted">{r.actor} · {formatDateTime(r.at)}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
